import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';

function getAdditionalInterest(
  name?: string,
  address?: string,
  previousAdditionalInterest?: { name?: string; address?: string } | null
) {
  const newAdditionalInterest = pickBy({ name, address }, (val) => val);
  const isPreviousAdditionalInterestEmpty = isEmpty(previousAdditionalInterest);
  const isCurrentAdditionalInterestEmpty = isEmpty(newAdditionalInterest);

  if (!isPreviousAdditionalInterestEmpty && isCurrentAdditionalInterestEmpty) {
    return {
      deleted: true,
    };
  }
  if (isCurrentAdditionalInterestEmpty) {
    return null;
  }

  return newAdditionalInterest;
}

export default getAdditionalInterest;
